import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "../../config";
import { usePaxContext } from "../../contexts/PassengerContext";

const JourneyType = ({ returnJourney, onTypeSelect }) => {
  // const [type, setType] = useState("Round Trip");
  // const { passengers } = usePaxContext();

  const handleTypeSelect = (type) => {
    // setType(type === true ? "Round Trip" : "One Way");
    onTypeSelect(type);
  };
  // let selectedPax = passengers.filter((pax) => pax.selected);
  // let isAllSelf = selectedPax.every((pax) => pax.paymentType === "self paid");
  return (
    <TypeContainer>
      <JourneyTypeItem
        onClick={() => handleTypeSelect(false)}
        active={!returnJourney}
      >
        One Way
      </JourneyTypeItem>
      <JourneyTypeItem
        active={returnJourney}
        onClick={() => handleTypeSelect(true)}
      >
        Round Trip
      </JourneyTypeItem>
    </TypeContainer>
  );
};

const TypeContainer = styled.div`
  height: 2.5rem;
  background: ${Colors.lightGray};
  border-radius: 1.25rem;
  display: flex;
  align-items: center;
  @media only screen and (max-width: 768px) {
    margin-top: 1rem;
    width: 100%;
  }
`;

const JourneyTypeItem = styled.button`
  border: none;
  padding: 0 1rem;
  background: ${(props) =>
    props.active ? Colors.pomegranate : Colors.lightGray};
  color: ${(props) => (props.active ? Colors.white : Colors.coolGreyOpacity50)};
  border-radius: 1.25rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  cursor: pointer;
  transition: color 0.1s ease-in;
  @media only screen and (max-width: 768px) {
    width: 50%;
    justify-content: center;
  }
`;

export default JourneyType;
